import tw from 'twin.macro';

export const linkStyles = tw`inline-flex items-center space-x-2 text-blue underline font-semibold hover:(text-blue-800 no-underline)`;
